function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a3v5vqnh5a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "1ecojaj7ub",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m150.585 99.882-43.096 25.352c-23.802 14.001-54.447 6.057-68.448-17.745-14.001-23.801-6.057-54.447 17.745-68.448L99.882 13.69l50.703 86.192z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m150.585 99.882.761 1.293 1.293-.76-.761-1.293-1.293.76zM99.882 13.69l1.293-.76-.76-1.294-1.293.76.76 1.294zM56.786 39.04l-.76-1.293.76 1.293zm50.703 86.193-.761-1.293.761 1.293zm42.336-26.644-43.097 25.351 1.521 2.586 43.097-25.352-1.521-2.585zM57.546 40.334l43.097-25.352-1.521-2.585-43.097 25.351 1.521 2.586zM98.59 14.45l50.703 86.193 2.586-1.521-50.703-86.193-2.586 1.521zM40.334 106.73c-13.581-23.088-5.875-52.814 17.212-66.395l-1.52-2.586C31.51 52.17 23.325 83.734 37.747 108.25l2.586-1.521zm66.394 17.212c-23.087 13.581-52.813 5.875-66.394-17.212l-2.586 1.521c14.421 24.515 45.986 32.698 70.501 18.277l-1.521-2.586z",
  fill: "#4E5EFA",
  mask: "url(#1ecojaj7ub)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a3v5vqnh5a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(-120.466 77.4 64.738)",
  d: "M0 0h120v120H0z"
})));

function SvgFigure2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure2);
export default __webpack_public_path__ + "static/media/figure-2.49ad4147.svg";
export { ForwardRef as ReactComponent };